import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const PortalIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.5 21.5",
    height: getDefaultHeight(svgProps, 21.5),
    ...svgProps,
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    children: [/*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: ".75",
      y: ".75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: "8.75",
      y: ".75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: "16.75",
      y: ".75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: ".75",
      y: "8.75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: "8.75",
      y: "8.75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: "16.75",
      y: "8.75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: ".75",
      y: "16.75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: "8.75",
      y: "16.75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4",
      height: "4",
      x: "16.75",
      y: "16.75",
      rx: "1.5"
    })]
  });
};

export { PortalIcon };
//# sourceMappingURL=portal.js.map
